<template>
  <div class="form-link-npa">
    <v-btn class="btn-add-category" :aria-label="$t('Добавить ссылку')" @click.native.stop="linkdialog = true">
      <span class="pro-icon-add" aria-hidden="true"></span>
    </v-btn>
    <v-dialog v-model="linkdialog" max-width="400">
      <v-card class="modal">
        <div class="modal-head">
          {{ $t('Ссылки на НПА') }}
          <v-btn color="modal-close" :aria-label="$t('Закрыть')" @click.native="linkdialog = false">
            <span class="pro-icon-close1" aria-hidden="true"></span>
          </v-btn>
        </div>
        <div
          class="modal-body"
          :class="{invalid: $v.link.$error}"
        >
          <v-text-field
            v-model="link"
            :aria-label="$t('Ссылка')"
            :aria-invalid="$v.link.$error ? 'true' : 'false'"
            outlined
            rounded
            dense
            ref="textField"
            @blur="$v.link.$touch()"
          />
          <v-btn rounded color="primary" dark @click="fetchLinks">
            {{ $t('Добавить') }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <ul class="link-list">
      <li v-for="(item, index) of linkList" :key="index">
        <a :href="item" target="_blank" class="link-npa">{{ item }}</a>
        <span
          class="pro-icon-close"
          role="button"
          tabindex="0"
          :aria-label="$t('Удалить') + ': ' + item"
          @click="deletelink(index)"
          @keydown.enter.prevent="deletelink(index)"
          @keydown.space.prevent="deletelink(index)"
        ></span>
      </li>
    </ul>
  </div>
</template>

<script>
  import { url } from 'vuelidate/lib/validators'

  export default {
    data: () => ({
      link: 'http://',
      linkList: [],
      linkdialog: false
    }),
    validations: {
      link: { url }
    },
    methods: {
      fetchLinks () {
        if (this.$v.$invalid) {
          this.$v.$touch()

          return
        }

        if (this.link != '' && typeof this.link !== 'undefined') {
          this.linkList.push(this.link)
        }

        this.$refs.textField.reset()
        this.$emit('fetchLinks', this.linkList)
      },
      resetLinks () {
        this.linkList = []
        this.linkdialog = false
      },
      deletelink (index) {
        this.linkList.splice(index, 1)
      }
    }
  }
</script>
